import { z } from "zod";

export const giftAddressSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  address1: z.string().min(1),
  address2: z.string().default(""),
  city: z.string().min(1),
  zip: z.string().min(1),
  country_code: z.string().min(2),
});

export type GiftAddressFormValues = z.infer<typeof giftAddressSchema>;
